module.exports = __webpack_public_path__ + "img/facebook-icon.2480ae73.svg";